import { getDataSource } from "api/ds";
import { ReportTable } from "./reportTable";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, IconButton, Menu, MenuItem, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { FindTextField } from "./FindTextField";
import { useNavigate } from "react-router-dom";
import handleConfirm from "./AlertMessage";
import { useDataContextDeal } from "actions/contextDealClient";
import Loading from "./Load";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useLocalNotifications } from "./Events";
import usePreventDoubleClick from "./AntiDBC";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import * as XLSX from 'xlsx';
import { MarketClientSelector } from "store/slices/marketClient";
import { get, getFile } from "api/apiBridges/httpBridge";
import { el } from "date-fns/locale";
import ClassicSearch from "./classicSearch";
import { Warehouse } from "@mui/icons-material";
import { downloadOZONTemplateWithDelivery, downloadSimpleTemplate, TemplateExcel } from "./excelTemplates";
import { sortProducts } from "utils/globalSorts";
import { hoverStyle } from "styles/main";
import { CancelButton, OKButton } from "./EIComponents/LittleComponents";


// компонент для добавления товаров в поставку
// cancel - для закрытия окна
// navigateDeal - для перехода в сделку после добавления товаров (нужен чтобы была универсальность, добавлять товары в сделке и перед ней)
// export function AddProducts({ cancel, navigateDeal = true, defMarket = undefined, isDelivery=true}) {
export function AddProducts({ cancel, navigateDeal = true, defMarket = undefined}) {
    // состояние для хранения данных, ошибок, загрузки и выбранных товаров
    const [data, setData] = useState([]);
    const [multiWay, setMultiWay] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    // функция для установки контекстных данных в Deal
    const { setContextData } = useDataContextDeal();
    // загрузка дескриптора
    const ds = useMemo(() => getDataSource('addProducts'), []);
     // хук для перехода по маршрутам
    const navigate = useNavigate();
    // хук для получения темы
    const theme = useTheme();

    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
            size: {name: "Размер", active: true},
            color: {name: "Цвет", active: true},
        }
    );

    
    

    const { user_id } = useSelector(
        loginSelector
    );
    
    const { market } = useSelector(MarketClientSelector);

    const preventDoubleClick = usePreventDoubleClick();
    const { showNotification } = useLocalNotifications();

    const fetchData = useCallback(async () => {
        // todo проверка какой маркет выбран
        // добавленный товар исключать путем запроса
        setLoading(true);

        let res = []
        let swkeymarket = defMarket || market
        let isToken = await get('Clients/checkClientAPIKey', {uid:user_id, market:market})
        console.log('IS TOKEN', isToken)
        console.log("market", market)
        switch (swkeymarket) {
            case "wb":
                if (isToken){
                    res = await ds.GetWBCardWithStocksAndStorage(user_id);
                }else {
                    showNotification({
                        id: 'checkToken', 
                        type: 'error', 
                        message: 'У вас не указан API ключ.' 
                    });
                }
                break;
            case "ozon":
                if (isToken){
                    res = await ds.GetOZONCardWithStocksAndStorage(user_id);
                }else {
                    showNotification({
                        id: 'checkToken', 
                        type: 'error', 
                        message: 'У вас не указан API ключ.' 
                    });
                }                
                break;
            case "consum":
                let resp = await get("consumables/getOnCli", {cid:user_id})
                res = []
                await Promise.all(resp.map(async (el) => {
                    let photo = undefined
                    let photopath = undefined
                    if (el.photo) {
                        let img = await getFile("png", {path:el.photo})
                        photopath = el.photo
                        photo = img
                    }
                    res.push(
                        {
                            nmID: `cons${el.id}`,
                            data: {
                                market:swkeymarket,
                                vendorCode: el.id,
                                brand: `user ${user_id}`,
                                title: el.title,
                                photo,
                                photopath,
                                material: [],
                                color: [el.color],
                                // showSize: el.size,
                                sizes: [
                                    {
                                        title: el.size,
                                        barcode: el.barcode,
                                        stocks: [],
                                        countQr: el.countQr || 0,
                                        total: 0,
                                        totalInRoad: 0,
                                        storage: el.count
                                    }
                                ],
                                totalCount: el.count,
                                totalInRoad: 0,
                                dimensions: el.dimensions,
                                consum: el.consum
                            },
                            rck: el.rck
                        }
                    )
                }))

                break;
            case "custom":
                res = await get("custom_product/get_card_with_stocks_and_storage", {cid:user_id})
                break;
        }
        
        let result = []
        // преобразуем под формат ui
        for (const el of res) {
            let elsizes = [...el.data.sizes]
            delete el.data.sizes
            elsizes.map((size) => {
                let obj = {
                    ...JSON.parse(JSON.stringify(el)), 
                    nmID: el.nmID || size.nmID ,//Делаем так, на случай, когда товары группируются не по nmID 
                    id:`${el.nmID || size.nmID};${size.barcode}`, 
                    size:size, 
                    techTask: size.techTask,
                    totalStorage: size.storage,
                    rck: el.rck
                }
                obj.data.vendorCode =  swkeymarket === "ozon"? size.vendorCode: el.data.vendorCode
                obj.data.sizeTitle = size.title
                obj.data.barcode = size.barcode
                console.log("obj", obj.data.vendorCode)
                result.push(obj)
                                
                if (selected.includes(el.id)) {
                    let idx = data.findIndex((fel) => el.id === fel.id)
                    if (idx > -1) {el.countProduct = data[idx].countProduct;}
                } else {
                    el.countProduct = 0;
                }
                
            })
        }
        console.log("result ADD", result)
        setData(result);
        setLoading(false);
    }, [ds, setData, selected]);

    useEffect(() => {
        fetchData();
    }, [market]);

    // переход к сделке с выбранными товарами
    // если есть ошибка или не выбраны товары, то выводим сообщение
    // если все ок, то собираем данные и передаем в контекст
    // и закрываем окно
    const goDeal = async () => {
        if (selected.length>0) {
            let res = []
            for (let sel of selected) {
                let idx = data.findIndex((el) => el.id === sel)
                if (idx > -1 ) {
                    if (data[idx].countProduct > 0) {
                        res.push({...data[idx]})
                    }
                    else {
                        showNotification({
                            id: 'binderr', 
                            type: 'error', 
                            message: 'У товара не указано количество' 
                        });        
                        return 1
                    }
                }
                
            }
            // if (multiWay.length === 0) {setContextData({ deal: res, isDelivery});}
            // else {setContextData({ deal: res, multiWay, isDelivery });}
            if (multiWay.length === 0) {setContextData({ deal: res});}
            else {setContextData({ deal: res, multiWay });}
            if (navigateDeal) navigate('deal');
            cancel(false);
        }
        else {
            showNotification({
                id: 'binderr', 
                type: 'error', 
                message: 'Ни один товар не выбран' 
            });
        }
    }

    const onSelect = (select) => {
        console.log("select", select)
        setSelected(select);
    };

    const onChangeCount = (idata) => {
        let tmp = [...data]
        let idx = tmp.findIndex((el) => el.id === idata.row.id)
        if (idx > -1) {
            tmp[idx].countProduct = idata.count
        }
        setData(tmp)
    }

    const handleFileUpload = async (event) => {
        // Получаем список выбранных файлов
        let files = Array.from(event.target.files);
        if (files.length === 0) return;

        // Копируем текущие данные, чтобы мутировать их в процессе обработки
        let tmp = JSON.parse(JSON.stringify(data));
        let seltmp = [];
        let tmpMultiWay = [];

        // Создаём массив промисов для каждого файла
        const filePromises = files.map((file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        // @ts-ignore
                        const $data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read($data, { type: 'array' });
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                        let c1, c2, c3;

                        switch (market) {
                            case 'wb':
                                c1 = jsonData
                                    .map(row => row[0])
                                    .filter(value => value !== undefined)
                                    .slice(1);
                                c2 = jsonData
                                    .map(row => row[1])
                                    .filter(value => value !== undefined)
                                    .slice(1);

                                c1.forEach((el, index) => {
                                    let idx = tmp.findIndex((fel) => fel.size.barcode === String(el));
                                    if (idx > -1) {
                                        if (tmp[idx].countProduct) {
                                            tmp[idx].countProduct += c2[index];
                                        } else {
                                            tmp[idx].countProduct = c2[index];
                                        }
                                        if (!seltmp.includes(tmp[idx].id)) {
                                            seltmp.push(tmp[idx].id);
                                        }
                                    }
                                });
                                break;

                            case 'ozon':
                                let needMW = jsonData[0]?.length > 2;
                                c1 = jsonData
                                    .map(row => row[2]) // ozonID
                                    .filter(value => value !== undefined)
                                    .slice(1);
                                c2 = jsonData
                                    .map(row => row[5]) // count
                                    .filter(value => value !== undefined)
                                    .slice(1);
                                c3 = jsonData
                                    .map(row => row[1]) // склад
                                    .filter(value => value !== undefined)
                                    .slice(1);

                                c1.forEach((el, index) => {
                                    let idx = tmp.findIndex((fel) => fel.size.ozonID === el);
                                    if (idx > -1) {
                                        if (needMW) {
                                            tmpMultiWay.push({
                                                ozonID: el,
                                                barcode: tmp[idx].size.barcode,
                                                warehouse: c3[index],
                                                count: c2[index]
                                            });
                                        }
                                        if (tmp[idx].countProduct) {
                                            tmp[idx].countProduct += c2[index];
                                        } else {
                                            tmp[idx].countProduct = c2[index];
                                        }
                                        if (!seltmp.includes(tmp[idx].id)) {
                                            seltmp.push(tmp[idx].id);
                                        }
                                    }
                                });
                                break;

                            default:
                                break;
                        }

                        resolve(); // Файл обработан успешно
                    } catch (err) {
                        reject(err);
                    }
                };
                reader.onerror = reject;
                reader.readAsArrayBuffer(file);
            });
        });

        try {
            // Ждём завершения обработки всех файлов
            await Promise.all(filePromises);

            // Проверяем, были ли найдены товары
            if (seltmp.length === 0) {
                showNotification({
                    id: 'err',
                    type: 'error',
                    message: 'Ни один товар не выбран'
                });
                event.target.value = null;
                return;
            }

            // Обновляем состояния только после обработки всех файлов
            let existSel = JSON.parse(JSON.stringify(selected));
            for (let s of seltmp) {
                if (!existSel.includes(s)) {
                    existSel.push(s);
                }
            }

            setSelected(existSel);
            setData(tmp);

            if (tmpMultiWay.length > 0) {
                setMultiWay(JSON.parse(JSON.stringify(multiWay)).concat(tmpMultiWay));
            }

            showNotification({
                id: 'load_success',
                type: 'success',
                message: `Успешно добавлено товаров: ${seltmp.length}`
            });
        } catch (error) {
            console.error('Ошибка при чтении файлов:', error);
            showNotification({
                id: 'err',
                type: 'error',
                message: 'Ошибка обработки файлов'
            });
        }

        // Очищаем поле ввода, чтобы можно было загрузить те же файлы снова
        event.target.value = null;
    };

    const selectedSummary = useMemo(() => {
        const selectedItems = data.filter(item => item.countProduct > 0);
        const totalQuantity = selectedItems.reduce((sum, item) => sum + (Number(item.countProduct) || 0), 0);
        
        return {
            uniqueCount: selectedItems.length,
            totalQuantity
        };
    }, [data]);



    if (loading) return (
       
            <Loading></Loading>
       
    )

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
                backgroundColor: theme.palette.background.default,
            }}
        >
            {/* Заголовок */}

            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 2, justifyContent:'space-between'}}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: "bold",
                        color: "text.primary",
                    }}
                >
                    Добавить товары в сделку
                </Typography>
                
                <Typography variant="h5" sx={{ color: "text.secondary", fontWeight: 'normal' }}>
                    Выбрано: {selectedSummary.uniqueCount} SKU (всего: {selectedSummary.totalQuantity} шт.)
                </Typography>
            </Box>


            {/* Поле поиска */}
            <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>
                <Box >
                    <ClassicSearch 
                        setChecked={setChecked} 
                        setFilter={setFilter} 
                        checked={checked}
                        fields={filterFields}
                        setFields={setFilterFields}
                    />
                </Box>
                <input
                    type="file"
                    accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    style={{ display: "none" }}
                    id="upload-excel"
                    onChange={handleFileUpload}
                    multiple          
                    //disabled={upload}
                />
                <Tooltip title="Загрузить из таблицы">
                    <IconButton>
                        <label htmlFor="upload-excel" 
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: 0,
                                padding: 0,
                                cursor: 'pointer',
                            }}>
                            <FileUploadIcon
                                sx={{
                                    transition: 'all 0.3s ease',
                                    '&:hover': hoverStyle
                                }}
                            />
                        </label>
                    </IconButton>
                </Tooltip>
                <TemplateExcel list = {market === 'ozon'? ['simpleTeplateCreateDelivery', 'warehouseTeplateCreateDeliveryOzon'] : ['simpleTeplateCreateDelivery']}/>
            </div>

            {/* Таблица с прокруткой */}
            <Box
                sx={{
                    flex: 1,
                    overflow: "auto",
                    borderRadius: 2,
                }}
            >
                <ReportTable
                    ds={ds}
                    data={!checked? sortProducts(data): sortProducts(data.filter((el) => {
                        const tf = filter.toLowerCase(); 
                        return (
                            filterFields.title.active &&
                                el.data.title &&
                                String(el.data.title).toLowerCase().includes(tf) || 
                            filterFields.brand.active &&
                                el.data.brand &&
                                String(el.data.brand).toLowerCase().includes(tf) || 
                            filterFields.vendorCode.active &&
                                el.data.vendorCode &&
                                String(el.data.vendorCode).toLowerCase().includes(tf) || 
                            filterFields.color.active &&
                                el.data.color &&
                                el.data.color.join('').toLowerCase().includes(tf) ||
                            filterFields.barcode.active &&
                                el.size.barcode &&
                                String(el.size.barcode).toLowerCase().includes(tf) ||
                            filterFields.size.active &&
                                el.size.title &&
                                String(el.size.title).toLowerCase().includes(tf)
                        )}))
                    }
                    onSelect={onSelect}
                    onFormatterChange={onChangeCount}
                    inputSelected={selected}
                    autoPagination={15}
                />
            </Box>

            {/* Нижняя панель с кнопками и полем ввода */}
            <Box

                sx={{
                    mt: 'auto',
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: 'space-between',
                    width: "100%",
                    alignItems: 'flex-end'
                }}
            >
                <CancelButton action={() => cancel(false)} text={"ОТМЕНА"}/>
                <OKButton action={preventDoubleClick(goDeal, 1000)} text={"ДОБАВИТЬ"}/> 
            </Box>
        </Box>
    );
}